export default {
  name: 'stepper',
  label: '步进器',
  dataType: 'Number',
  icon: 'el-icon-files',
  config: [{
    // 可修改的配置选项
    xtype: 'text',
    options: {
      label: '输入提示',
      name: 'placeholder',
      default: '请输入'
    }
  }, {
    // 可修改的配置选项
    xtype: 'stepper',
    options: {
      dataType: 'Number',
      label: '步数',
      name: 'step',
      default: 1,
      min: 1
    }
  }]
};